import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";
import { useAuth } from "../../../context";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { IoLogInOutline } from "react-icons/io5";

function LoginForm() {
  const { t } = useTranslation();
  const { handleLogin } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    setIsLoading(true);
    const response = await fetch(API_URL + '/login', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone_number: phoneNumber, password }),
    });
    const data = await response.json();
    if (data.success) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'user-id', userId: data.user.id, token: data.token })
        );
      }
      handleLogin(data);
      navigate(data.user.phone_verified_at ? "/" : "/otp");
    } else {
      toast.error(data.message || "حدث خطأ أثناء تسجيل الدخول");
    }
    setIsLoading(false);
  };

  return (
    <div>
      <div className="auth-group">
        <label className="auth-label">{t('auth.tabs.login.fields.phone_number.label')}</label>
        <input
          className="auth-input"
          type="tel"
          inputMode="numeric"
          placeholder={t('auth.tabs.login.fields.phone_number.placeholder')}
          value={phoneNumber}
          onChange={e => setPhoneNumber(e.target.value)}
        />
      </div>

      <div className="auth-group">
        <label className="auth-label">{t('auth.tabs.login.fields.password.label')}</label>
        <input
          className="auth-input"
          type="password"
          placeholder={t('auth.tabs.login.fields.password.placeholder')}
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
      </div>

      <div className="auth-group">
        <Link to="/password_recovery" className="auth-forgot">
          {t('auth.tabs.login.password_reset_link')}
        </Link>
      </div>

      <button
        className="auth-submit"
        onClick={login}
        disabled={isLoading || phoneNumber.length < 8 || password.length < 8}
      >
        {isLoading
          ? <span className="spinner-border spinner-border-sm" />
          : <IoLogInOutline size={20} />
        }
        {t('auth.tabs.login.button')}
      </button>
    </div>
  );
}

export default LoginForm;
